<template>
  <div>
    <div class="update-box flex_c_m">
      <div class="upd-left">
        <van-uploader accept="*" :after-read="afterRead">
          <div>上传报名文件（压缩包）</div>
        </van-uploader>
      </div>
      <div @click="showTotle" class="upd-right">附件要求</div>
    </div>
    <van-tag 
      v-for="(e,i) in fileUrl" :key="i" 
      plain
      closeable size="medium" 
      type="success" 
      class="tab-boxs"
      @close="closetab" 
    > {{e||'--'}} </van-tag>
  </div>
</template>

<script>
import {ossUpload} from '@utils/ossUpload.js'
export default {
  data(){
    return{
      inoftext:
        `
        1、这里是要求展示模块前台说明：投票是需要根据投票资格来限定投票次数。
        2、投票资格的四个类型在后台可以配置。如果是不允许的投票角色，则提示资格说明。比如说不允许匿名。
        3、投票则提示：【匿名游客不能参与投票，关注公众号每天可投2票，注册用户每天可投3票，实名认证用户每一可投5票】
        4、多张图片时，图片可以左右滑动。图片上传时要求压缩图片，压缩后的图片应不大于1M（在系统中可配置该限制参数）
        `,
      fileUrl:[]  
    }
  },
  methods:{
    showTotle(){
      this.$dialog.alert({
        title: '附件要求',
        message: this.inoftext,
      }).then(() => {
        // on close
      });
    },
    // 文件读取完成后的回调函数
    afterRead(e) {
      if(this.fileUrl.length>=1){
        this.$toast('最多上传一份文件');
        return;
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        message: '上传中...',
      });
      ossUpload({ file: e.file }, res => {
        // console.log(res);
      }, res => {
        this.$emit('onSuccess',res.url);
        this.fileUrl = [res.url];
        this.$toast.clear();
      }, err => {
        this.$toast('文件上传失败')
        // console.log(err);
      });
    },
    closetab(){
      this.fileUrl = [];
      this.$emit('onSuccess','');
    }
  }
}
</script>

<style lang="scss" scoped>
.update-box{
  width: 100vw;
  height: 30px;
  margin-bottom: 10px;
  .upd-left{
    width: 50%;
    color:#38C7B4;
    font-size:14px;
    padding-left: 25px;
  }
  .upd-right{
    width: 50%;
    color:#999;
    font-size:12px;
    text-align: right;
    padding-right: 25px;
  }
}
.tab-boxs{
  margin: 6px 25px;
}
</style>
